/**
 * Header 组件
 * Memory 模块简化版 Header，只显示通知和用户名
 * 完整的用户管理功能在 Agent Dashboard 中
 */

import { useAuthStore } from '@/shared/store/authStore'
import { User } from 'lucide-react'
import { NotificationCenter } from '@/shared/components/notification'
import type { Notification } from '@/shared/components/notification'

interface HeaderProps {
  notifications?: Notification[]
  onNotificationClick?: (notification: Notification) => void
  onRetry?: (notificationId: string) => void
  onClearNotifications?: () => void
  onMarkAllRead?: () => void
}

export default function Header({
  notifications = [],
  onNotificationClick,
  onRetry,
  onClearNotifications,
  onMarkAllRead,
}: HeaderProps) {
  const { user } = useAuthStore()

  return (
    <header className="h-14 px-6 flex items-center justify-end gap-4 bg-card border-b border-border shadow-sm">
      {/* Notification Center */}
      <NotificationCenter
        notifications={notifications}
        onNotificationClick={onNotificationClick}
        onRetry={(notificationId) => {
          // 从notification的metadata中获取sessionId
          const notification = notifications.find(n => n.id === notificationId)
          if (notification?.metadata?.sessionId && onRetry) {
            onRetry(notification.metadata.sessionId as string)
          }
        }}
        onClearAll={onClearNotifications}
        onMarkAllRead={onMarkAllRead}
      />

      {/* User Info - 简化显示，只显示用户名 */}
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-secondary">
        <User className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm text-foreground">
          {user?.name || user?.nickname || user?.id}
        </span>
      </div>
    </header>
  )
}

